<template>
  <div
    class="radio-button-initial flex h-full flex-grow rounded-md bg-off-white p-0"
    :class="[
      { 'activeButton border-2': active },
      !active
        ? requireChecked
          ? 'validation-error border border-red-500 bg-red-100'
          : 'pre-validation border-2 border-transparent hover:border-light-gray'
        : 'border-2 border-transparent',
    ]"
  >
    <label
      class="container-checkbox w-full"
      :class="{ activeButtonText: active }"
    >
      <slot name="beforeText" />
      <span
        class="leading-tight"
        :class="customClasses"
      >
        {{ item }}
      </span>
      <slot name="afterText" />
      <input
        type="checkbox"
        :name="name"
        :value="item"
        :checked="active"
        :disabled="disabled"
        @click="handleSelect"
      />
      <span class="checkmark-checkbox" />
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  props: {
    item: String,
    activeItems: Array,
    handleSelect: {
      type: Function,
    },
    name: [String, Number],
    active: [Boolean, Object],
    requireChecked: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    customClasses: {
      type: String,
      default: '',
      required: false,
    },
  },
};
</script>

<style>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
.container-checkbox input[disabled] {
  pointer-events: none;
  opacity: 0.5;
}

.container-checkbox {
  @apply relative flex min-h-12 cursor-pointer items-start pb-3 pl-12 pr-4 pt-3.75 text-left text-xs text-body-color sm:text-sm;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container-checkbox input {
  @apply absolute h-0 w-0 cursor-pointer opacity-0;
}

/* Create a custom checkbox */
.checkmark-checkbox {
  @apply absolute left-2 h-6 w-6 rounded-md bg-white;
  top: 1.5rem;
  transform: translate(0, -50%);
}

.validation-error .checkmark-checkbox {
  @apply border border-red-500;
}

.pre-validation .checkmark-checkbox {
  @apply border-2 border-white;
}

.pre-validation:hover .checkmark-checkbox {
  @apply border-light-gray;
}

/* When the checkbox is checked, add a yellow background */
.container-checkbox input:checked ~ .checkmark-checkbox {
  @apply bg-yellow-500;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark-checkbox:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container-checkbox input:checked ~ .checkmark-checkbox:after {
  display: block;
}

/* Style the checkmark/indicator */
.container-checkbox .checkmark-checkbox:after {
  left: 8px;
  top: 2px;
  width: 9px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.radio-button-initial.activeButton {
  /* @apply flex flex-wrap p-3 bg-white border-yellow-500 border-2 rounded-md; */
  @apply flex flex-wrap rounded-md border-2 border-yellow-500 bg-white;
  border-color: #f8c617 !important;
  background-color: white !important;
}

.activeButtonText {
  @apply text-dark-gray;
}
</style>
